import type { EffectiveCharacteristic } from "@/types/batches.types";

/** Como uma característica efetiva é lida em uma linha: "Tipo A", "misto: Tipo A, Tipo B", "não informado". */
export function effectiveLabel(c: Pick<EffectiveCharacteristic, "state" | "values">): string {
  const labels = c.values.map((v) => v.label).filter(Boolean);
  if (c.state === "NONE" || labels.length === 0) return "não informado";
  if (c.state === "MIXED") return `misto: ${labels.join(", ")}`;
  return labels.join(", ");
}

/** A procedência em texto — nunca só por cor (design system). */
export function provenanceLabel(c: EffectiveCharacteristic): string | null {
  if (c.state === "INHERITED" || c.state === "MIXED") {
    const from = c.inheritedFrom.map((o) => (o.runId ? o.label : `${o.label} (desfeita)`));
    return from.length > 0 ? `herdado de ${from.join(", ")}` : "herdado";
  }
  if (c.state === "OWN") {
    if (c.source === "ORDER") return "da ordem";
    if (c.source === "IMPORT") return "da importação";
    return "informado na tela";
  }
  return null;
}
